<xemex-dialog-shell [title]="titleKey | translate">
  <div class="p-2 flex flex-col gap-4">
    <span>
      {{ messageKey | translate: { owner: data.ownerPartnerName, guest: data.guestPartnerName } }}
    </span>

    @if (isExtend) {
      <xemex-text-field
        [formControl]="reviewDueDate"
        type="date"
        [label]="'partnerships.table.endDate' | translate"
        [required]="true"
        [invalid]="reviewDueDate.invalid && reviewDueDate.touched"
        [errorText]="
          'error.required' | translate: { field: ('partnerships.table.endDate' | translate) }
        "
      />
    }

    @if (isAccept) {
      <div class="flex flex-col gap-2">
        <mat-checkbox [checked]="termsAgreed()" (change)="onToggleTerms($event.checked)">
          <span class="text-sm">{{ 'partnerships.actions.accept.agree' | translate }}</span>
        </mat-checkbox>
        <xemex-link-button class="text-sm w-fit" (click)="onViewTerms()">
          {{ 'partnerships.actions.accept.viewTerms' | translate }}
        </xemex-link-button>
        @if (termsTouched() && !termsAgreed()) {
          <span class="text-sm text-red-500">
            {{ 'partnerships.actions.accept.termsRequired' | translate }}
          </span>
        }
      </div>
    }
  </div>

  <mat-dialog-actions actions>
    <xemex-filled-button
      type="button"
      [intent]="isDestructive ? 'destructive' : 'primary'"
      (click)="onConfirm()"
    >
      {{ confirmKey | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
